<template>
  <el-upload
    :disabled="readonly"
    class="upload-input"
    ref="upload"
    :loading="loading"
    drag
    :action="uploadUrl"
    :before-upload="handleBeforeUpload"
    :http-request="submitUpload"
    :show-file-list="false"
    :accept="accept">
    <img v-if="imagePreview" style="object-fit: cover" :src="imagePreview" @error="bindAvatarErr($event)">
    <div class="uploadTip">
      <img class="img-icon-upload" :src="uploadImgIcon" style="width:37px;height:auto;">
      <div class="el-upload__text">点击上传</div>
    </div>
    <slot>
      <div class="el-upload__tip" slot="tip" :style="{'color': error ? 'red;margin-top: 0px;' : '@font-color-base;margin-top: 0px;'}">支持jpg/png不超过500KB</div>
    </slot>
  </el-upload>
</template>
<script>
  import { mapActions } from 'vuex'
  export default{
    name: 'uploadAvatar',
    props: {
      avatar: {
        type: String,
        default: '',
      },
      readonly: {
        type: Boolean,
        default: false
      },
      isUpload: {
        type: Boolean,
        default: true
      },
      accept: {
        type: String,
        default: ''
      },
      size: {
        default: 1024 * 500
      }
    },
    data() {
      return{
        loading: false,
        uploadUrl: 'USER.UPLOAD_USER_IMG',
        uploadFile: null,
        imagePreview: this.avatar,
        error: false,
        uploadImgIcon: require('@/assets/img/uploadAvatarBtn.png'),
        defaultAvatar: require('@/assets/img/defaultAvatar.png')
      }
    },
    watch: {
      avatar(val) {
        if(val && val.indexOf('http') > -1){
          this.imagePreview = val+'?t='+Math.random();
        }
        if(!val){
          this.imagePreview = ''
        }
      },
      error(to) {
        if(to) {
          $('.el-upload-dragger').css('border-color', 'red');
        }else{
          $('.el-upload-dragger').css('border-color', '#d9d9d9');
        }
      }
    },
    methods: {
      ...mapActions([
        'alertToggle',
        'upload'
      ]),
      bindAvatarErr(e) {
        e.target.src = this.defaultAvatar
      },
      handleBeforeUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt500K = file.size < this.size;
        if (!isJPG) {
          this.$emit('input-change', this.avatar, 'type')
          this.error = true
        }else if(!isLt500K){
          this.$emit('input-change', this.avatar, 'size')
          this.error = true
        }else{
          this.uploadFile = file

        }
        return isJPG && isLt500K;
      },

      handleUploadSuccess(res) {
        this.loading = false
        this.error = false
        this.imagePreview = URL.createObjectURL(this.uploadFile)
        this.$emit('input-change', res.imageName)
        this.alertToggle({
          alertType: 'success',
          alertContent: '上传头像成功'
        })
      },
      submitUpload() {
        if (!this.isUpload) {
          let _this = this
          this.$emit('input-change', this.uploadFile)
          let reader = new FileReader()
          reader.readAsDataURL(this.uploadFile)
          reader.onload = function(e) {
            _this.imagePreview = e.target.result
          }
          return
        }
        let url = this.uploadUrl
        let params = {
          file: this.uploadFile
        }
        const _this = this
        _this.loading = true
        this.upload({url, params}).then(res => {
          _this.handleUploadSuccess(res)
        }).catch(err => {
          _this.loading = false
          _this.alertToggle({
            alertType: 'danger',
            alertContent: err
          })
        })
      },
    }
  }
</script>

<style lang="less" scoped>
.uploadTip{
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // background: @theme-bg-color;
  .el-upload__text{
    margin-top: 16px;
  }
}
.el-upload__tip{
  margin: 7px auto !important;
}

</style>
